<template>
    <div>
        <div v-for="(field, index) in form.fields" :key="field.id">
            <p class="form-label"><b>{{index + 1}}. {{field.label.EN}}</b></p>
            <ol type="a" class="mt-4" v-if="field.valueType === 'OPTION' || field.valueType === 'MULTIPLE_OPTION'">
                <li v-for="option in field.valueOptions" :key="option.localizedStringMap.EN">
                    {{option.localizedStringMap.EN}}
                </li>
            </ol>
            <el-divider/>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FormPreview',
    props: {
        form: Object,
    },
    data: function() {
        return {
            locValue: {},
        }
    },
    methods: {

    },
    mounted() {

    },
    watch: {

    }
}
</script>